import { render, staticRenderFns } from "./xy-inner-pagelet-selector.vue?vue&type=template&id=5af71fe7"
import script from "./xy-inner-pagelet-selector.vue?vue&type=script&lang=js"
export * from "./xy-inner-pagelet-selector.vue?vue&type=script&lang=js"
import style0 from "./xy-inner-pagelet-selector.vue?vue&type=style&index=0&id=5af71fe7&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports